// In-app notifications API — backs the header bell.
//
// Live updates arrive via Socket.io 'notification:new' (see NotificationBell
// for the listener). These helpers cover load / mark-read / mark-all-read.
import api from './api';

export const fetchNotifications = async ({ status = 'all', limit = 30 } = {}) => {
  const res = await api.get(`/notifications?status=${encodeURIComponent(status)}&limit=${limit}`);
  return res.data; // { notifications: [...], unread_count: N }
};

export const markNotificationRead = async (id) => {
  const res = await api.post(`/notifications/${id}/read`);
  return res.data;
};

export const markAllNotificationsRead = async () => {
  const res = await api.post('/notifications/read-all');
  return res.data;
};
